import styled from "styled-components";
import { Tag as AntTag } from "antd";

export const StyledStatusTag = styled(AntTag)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 120px;
  padding: 4px 16px;
  border-radius: 30px;
  border: none;
  background: ${(props) => props.$background};
  color: ${(props) => props.$color};
  font-family: "Switzer", "Inter", "Helvetica", "Arial", sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  white-space: nowrap;
  margin: 0;
`;
